// Ported verbatim from earthPlace-public/support.html. This is now the live
// copy: edit it here, not in that repo.
import React from "react";
import {DocSection} from "./docPage";

export const supportUpdated = "17 September 2026";

export const supportIntro = null;

export const supportSections: DocSection[] = [
    {
        id: "contact",
        title: "Contact",
        body: <>
            <p><span className="pj-email-line">Email <a href="mailto:noureldinesamehelfangary@gmail.com">noureldinesamehelfangary@gmail.com</a>.</span>earthPlace is made by one person, so replies take as long as they take, but every message is read.</p>
        </>,
    },
    {
        id: "using-earthplace",
        title: "Using earthPlace",
        body: <>
            <p>earthPlace is for ages 13 and over.</p>
            <p>Blocks you place on a public layer are visible to anyone who visits that place, along with the display name you were using at the time. Layers you create appear on the map to people nearby, with their name, location, and a photo taken from your camera as the layer's picture. Private layers and blueprints stay on your device and go only to people you share them with.</p>
            <p>Look up and around. Don't play in traffic, on private property, or anywhere you shouldn't be. Nothing in the app is worth your safety, and placing blocks somewhere doesn't give you any right to be there.</p>
        </>,
    },
    {
        id: "content-rules",
        title: "Content rules",
        body: <>
            <p>Nothing is checked before it appears. Build what you like: these rules are enforced when something is reported, not by screening what people make.</p>
            <p><strong>Not allowed anywhere.</strong> Reported content in these categories is removed, and the device that placed it can be restricted, without notice:</p>
            <ul>
            <li>content that sexualises or endangers children;</li>
            <li>sexually explicit content;</li>
            <li>hate, harassment, threats, or anything aimed at a person to upset them;</li>
            <li>content that impersonates someone, or that isn't yours to use.</li>
            </ul>
            <p><strong>The layer owner's call.</strong> Everything else is between you and whoever owns the layer. An owner can remove any user's blocks from their own layer and ban them from it for any reason: taste, style, or blocks placed over what was already there. That layer is theirs to run.</p>
        </>,
    },
    {
        id: "reporting",
        title: "Reporting",
        body: <>
            <p>In the app: open a layer, tap the settings gear on it, then <strong>Report</strong>. You can report the layer itself or pick a user who has placed blocks on it. You can also hide a user's blocks on that layer from your own view, which takes effect straight away and affects nobody else.</p>
            <p>If you own the layer, the same sheet lets you remove that user's blocks from it yourself, without waiting for a review.</p>
            <p>You can also email reports to the address above.</p>
        </>,
    },
    {
        id: "how-moderation-works",
        title: "How moderation works",
        body: <>
            <p>Every report is reviewed by hand. There's no fixed response time: it's one person, and a deliberate promise of "within X hours" would be a promise I can't keep. Urgent things get looked at first.</p>
            <p>A report can end in:</p>
            <ul>
            <li><strong>No action</strong>, if nothing here was broken.</li>
            <li><strong>A warning</strong>, with the blocks removed.</li>
            <li><strong>A ban from that layer</strong>, with the blocks removed.</li>
            <li><strong>A 30-day suspension</strong> from public layers.</li>
            <li><strong>A ban from public layers.</strong></li>
            <li><strong>A ban from earthPlace</strong>, which also covers private layers and blueprints.</li>
            </ul>
            <p>Every outcome except "no action" removes the reported blocks. Restrictions apply to the device, so changing your display name doesn't lift one. A restricted device is told what was decided, and why, every time the app opens.</p>
        </>,
    },
    {
        id: "appeals",
        title: "Appeals",
        body: <>
            <p>The notice that tells you about a restriction has an <strong>Appeal</strong> button. You get one appeal per decision, and you'll be told the outcome in the app. If an appeal is refused, you can be allowed another at my discretion. You can also email the address above.</p>
        </>,
    },
    {
        id: "terms",
        title: "Terms",
        body: <>
            <p>earthPlace is provided as it is, with no promise that it will always work, keep your blocks, or stay available. Content you place stays yours; by placing it on a public layer you allow it to be shown to other people in the app. Breaking the rules above can cost you access.</p>
            <p>Whichever store you installed from also applies its own terms: Apple's standard licence terms for apps from the App Store, Google Play's terms of service on Android, and Meta's store terms on Quest. Nothing here takes away your statutory rights as a consumer.</p>
            <p>This page and the privacy policy are governed by the law of England and Wales. If you live elsewhere, nothing here stops you bringing a claim in the courts of the country you live in, where your local law gives you that right.</p>
        </>,
    },
];
